import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import {
	VueMasonryPlugin
} from "vue-masonry";
import axios from "axios";
import VueExcel from "vue-excel-export";


import * as echarts from "echarts";
import {
	createToast
} from '../src/views/ez/Stoast.vue'


createToast(Vue)
Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.use(VueExcel);
Vue.use(VueMasonryPlugin);
Vue.use(ElementUI);
Vue.config.productionTip = false;
new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");